export interface OrderProduct {
  id: number;
  name: string;
  quantity: number;
  boxQuantity?: number;
  productId: number | null;
  kitId: number | null;
  variationId: number;
  image: string | null;
  exchanged: boolean | undefined;
  receivedQuantity?: number | null;
}

export enum OrderStatus {
  PENDING = 1,
  DECLINED = 2,
  APPROVED = 3,
  IN_TRANSIT = 4,
  DELIVERED = 5,
  INBOUNDED = 6,
}

export interface OrderModel {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  riderId: string;
  orderDate: string;
  deliveryDate: string | null;
  status: OrderStatus;
  products: OrderProduct[];
  number: string;
  hasAccident: boolean;
  note?: string | null;
  inboundDate?: string | null;
  distributionCenter?: string | null;
  trackingNumber?: string | null;
  trackingLink?: string | null;
}
